export const indexDateSectionMessagesEn = {
  // Index Date Section
  'projects.cohortBuilderPage.setIndexDateDialog.description':
    'Assign an index date to the cohort you are creating.',
  'projects.cohortBuilderPage.setIndexDateDialog.titleSet': 'Index date',
  'projects.cohortBuilderPage.setIndexDateDialog.titleView': 'View index date',
  'projects.cohortBuilderPage.setIndexDateDialog.cancelBtnEditable': 'Cancel',
  'projects.cohortBuilderPage.setIndexDateDialog.cancelBtnView': 'Close',
  'projects.cohortBuilderPage.setIndexDateDialog.saveBtn': 'Set index date',
  'projects.cohortBuilderPage.setIndexDateDialog.typeLabel': 'Type',
  'our.cohortBuilder.setIndexDateDialog.typePlaceholder': 'Select type',
  'projects.cohortBuilderPage.setIndexDateDialog.eventLabel': 'Event',
  'projects.cohortBuilderPage.setIndexDateDialog.eventPlaceholder': 'Select event',
  'projects.cohortBuilderPage.setIndexDateDialog.noOptionsText': 'No instance events defined',
  'projects.cohortBuilderPage.setIndexDateDialog.calendarDateLabel': 'Date',
  'projects.cohortBuilderPage.setIndexDateDialog.restrictIndexDateCheckbox':
    'Restrict index date to occur within a specific date range.',
  'projects.cohortBuilderPage.setIndexDateDialog.startDateLabel': 'Start date',
  'projects.cohortBuilderPage.setIndexDateDialog.endDateLabel': 'End date',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateInvalidError':
    'Invalid format. Enter MM/DD/YYYY.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateMinDateError': 'Minimum date is {minDate}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateMaxDateError': 'Maximum date is {maxDate}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateFutureError': 'Maximum date is {today}.',
  'projects.cohortBuilderPage.setIndexDateDialog.calDateUnknownError':
    'Unknown date error {error}.',

  // New messages for redesigned UI
  'projects.cohortBuilderPage.setIndexDateDialog.title': 'Set index date',
  'projects.cohortBuilderPage.setIndexDateDialog.allFieldsRequired':
    'All fields are required unless marked optional.',
  'projects.cohortBuilderPage.setIndexDateDialog.nameLabel': 'Name',
  'projects.cohortBuilderPage.setIndexDateDialog.enterName': 'Enter name',
  'projects.cohortBuilderPage.setIndexDateDialog.ieCriteria': 'I/E criteria',
  'projects.cohortBuilderPage.setIndexDateDialog.inclusion': 'Inclusion',
  'projects.cohortBuilderPage.setIndexDateDialog.exclusion': 'Exclusion',
  'projects.cohortBuilderPage.setIndexDateDialog.notApplied': 'Not applied',
  'projects.cohortBuilderPage.setIndexDateDialog.eventRadioLabel': 'Event',
  'projects.cohortBuilderPage.setIndexDateDialog.eventInputLabel': 'Event',
  'projects.cohortBuilderPage.setIndexDateDialog.selectEvent': 'Select event',
  'projects.cohortBuilderPage.setIndexDateDialog.eventHelperText':
    'The date of the selected event will be used as the index date.',
  'projects.cohortBuilderPage.setIndexDateDialog.calendarDateRadioLabel': 'Calendar date',
  'projects.cohortBuilderPage.setIndexDateDialog.calendarInputLabel': 'Calendar',
  'projects.cohortBuilderPage.setIndexDateDialog.calendarHelperText':
    'The selected calendar date will be used as the index date for all patients.',
  'projects.cohortBuilderPage.setIndexDateDialog.timeWindow': 'Time window',
  'projects.cohortBuilderPage.setIndexDateDialog.restrictDateRange':
    'Restrict index date to occur within a specific date range',
  'projects.cohortBuilderPage.setIndexDateDialog.startDate': 'Start date',
  'projects.cohortBuilderPage.setIndexDateDialog.endDate': 'End date',

  // index date view card
  'projects.cohortBuilderPage.indexDateViewCard.fieldTypeLabel': 'Type',
  'projects.cohortBuilderPage.indexDateViewCard.fieldEventLabel': 'Event',
  'projects.cohortBuilderPage.indexDateViewCard.fieldDateLabel': 'Date',
  'projects.cohortBuilderPage.indexDateViewCard.fieldDateRangeLabel': 'Date range restriction',
  'projects.cohortBuilderPage.indexDateViewCard.setIndexDateBtnLabel': 'Set index date',
  'projects.cohortBuilderPage.indexDateViewCard.emptyMainMsg': 'No index date',
  'projects.cohortBuilderPage.indexDateViewCard.emptySubMsg': 'Set an index date to get started',
  'projects.cohortBuilderPage.indexDateViewCard.occurrence': 'Occurrence',
  'projects.cohortBuilderPage.indexDateViewCard.first': 'First',
  'projects.cohortBuilderPage.indexDateViewCard.last': 'Last',

  // calendar index date view card
  'projects.cohortBuilderPage.calendarIndexDateViewCard.description':
    'Index date is {date} for all the patients in this cohort.',

  // index date delete modal
  'projects.cohortBuilderPage.indexDateDeleteModal.title': 'Delete index date',
  'projects.cohortBuilderPage.indexDateDeleteModal.submittingTitle': 'Deleting index date',
};
